const rankingItems = [
  {
    rank: 1,
    title: '流浪地球3',
    type: '科幻 / 冒险',
    hot: '本周最热',
    medal: 'ri-medal-fill text-accent-500',
  },
  {
    rank: 2,
    title: '庆余年 第二季',
    type: '古装 / 权谋',
    hot: '全集上线',
    medal: 'ri-medal-fill text-background-400',
  },
  {
    rank: 3,
    title: '背着善宰跑',
    type: '爱情 / 穿越',
    hot: '热播中',
    medal: 'ri-medal-fill text-accent-600',
  },
  {
    rank: 4,
    title: '奔跑吧 第十二季',
    type: '综艺 / 真人秀',
    hot: '本期新更',
    medal: '',
  },
  {
    rank: 5,
    title: '沙丘3',
    type: '科幻 / 史诗',
    hot: '新片推荐',
    medal: '',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            热度榜单
          </h2>
          <p className="mt-3 text-sm text-foreground-500">本周最受欢迎的影视TOP5</p>
        </div>

        <div className="max-w-2xl mx-auto">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 px-5 py-4 bg-background-50 hover:bg-background-100 rounded-xl transition-colors cursor-pointer group"
            >
              <div className="w-8 text-center shrink-0">
                {item.rank <= 3 ? (
                  <i className={`${item.medal} text-xl w-6 h-6 flex items-center justify-center`}></i>
                ) : (
                  <span className="font-heading font-bold text-lg text-foreground-400">
                    {item.rank}
                  </span>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading font-semibold text-base text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{item.type}</p>
              </div>
              <div className="shrink-0">
                <span className="px-3 py-1 rounded-full bg-primary-50 text-primary-700 text-xs font-medium whitespace-nowrap">
                  {item.hot}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}